import { Grid } from "@mui/material";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Button from "../../../framework/Button";
import GlobalContext from "../../../framework/GlobalContext";
import Shortcut from "../../../framework/Shortcut";
import TextInput from "../../../framework/TextInput";
import { displayToast } from "../../../framework/toast/toastUtils";
import { saveSpeciality } from "../../../services/doctor-service";
import classes from "./index.module.css";

const EditSpeciality = ({
  specialityData,
  onSaveSpeciality = () => {},
  onEscape = () => {},
}) => {
  // const {
  //   focusElement,
  // } = useContext(GlobalContext);
  const [formState, setFormState] = useState({});
  const specialityNameRef = useRef("");
  const saveSpecialityRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);

  const validateForm = useCallback((formState) => {
    if (!formState?.specialityName?.trim()) {
      displayToast({
        type: "error",
        title: "Please enter speciality name.",
      });
      specialityNameRef.current?.focus();
      return;
    }
    return true;
  }, []);
  useEffect(() => {
    if (specialityData) {
      setFormState({
        specialityName: specialityData.name || "",
        id: specialityData.specialityId || null,
      });
    }
  }, [specialityData]);

  useEffect(() => {
    specialityNameRef.current?.focus();
  }, []);

  const updateSpecialityHandler = useCallback(
    async (e) => {
      if (!(await validateForm(formState))) return;
      const specialityPayload = {
        specialityId: formState.id,
        name: formState.specialityName,
      };
      const resp = await saveSpeciality(specialityPayload);
      if (!resp) {
        displayToast({
          type: "error",
          title: "Failed to save speciality.",
        });
        return;
      }
      onSaveSpeciality();
      return displayToast({
        type: "success",
        title: "Speciality updated successfully.",
      });
    },
    [formState, onSaveSpeciality, validateForm]
  );
  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "escape") {
        return onEscape();
      }
      if (event.ctrlKey && key === "s") {
        return saveSpecialityRef.current.click();
      }
    },
    [onEscape]
  );

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);
  return (
    <div>
      <h4 className={classes["speciality-detail-label"]}>Speciality Details</h4>
      <Grid container spacing={2} sx={{ p: "25px 20px" }}>
        <Grid item xs={12}>
          <TextInput
            id="speciality_name"
            ref={specialityNameRef}
            name="specialityName"
            label="Speciality Name"
            value={formState?.specialityName || ""}
            onFocus={() => setCurrentComponent("speciality_name")}
            onChange={(e) => {
              setFormState((prev) => {
                return {
                  ...prev,
                  specialityName: e.target.value,
                };
              });
            }}
            onBlur={() => validateForm(formState)}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "speciality_name",
                down: "edit_speciality_save_button",
                left: "speciality_name",
                right: "edit_speciality_save_button",
              }),
            }}
          />
        </Grid>
      </Grid>
      <div className={classes["edit-speciality-save-button-wrapper"]}>
        <Button
          id="edit_speciality_save_button"
          ref={saveSpecialityRef}
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          label="Save Speciality"
          color="violet"
          onClick={updateSpecialityHandler}
          markers={JSON.stringify({
            up: "speciality_name",
            left: "speciality_name",
            right: "edit_speciality_save_button",
            down: "edit_speciality_save_button",
          })}
        />
      </div>
    </div>
  );
};

export default EditSpeciality;
